import { useAtomValue } from 'jotai';
import * as yup from 'yup';
import { ISimpleChoice } from '../../../data-models/field2.data-model';
import { RendererType } from '../../../data-models/field-definition';
import { ISelectMeta } from '../../../data-models/field3.data-model';
import { dealStagesByIdMapState } from '../../DealFlow2/state/DealboardDataState';
import { schemaToFormFields } from '../../../util/schema-utils';

/**
 * Deal type config schema. A deal type has a name and the set of deal stages it
 * applies to. The stage options are loaded at runtime, so the schema is built
 * inside the hook (mirrors useGetKPIGroupField in KpiConfigForm.schema.ts).
 */
export function dealTypeConfigFormSchema(stageOptions: ISimpleChoice<number>[]) {
  return yup.object({
    name: yup.string().required().label('Name').formMeta({
      renderer: RendererType.text,
    }),
    dealStageIds: yup
      .array()
      .of(yup.number())
      .default([])
      .label('Deal Stages')
      .formMeta({
        renderer: RendererType.multiSelect,
        rendererMeta: { multi: true, values: stageOptions } as ISelectMeta<number>,
      }),
  });
}

export function useDealTypeFields() {
  const stages = useAtomValue(dealStagesByIdMapState);
  const stageOptions: ISimpleChoice<number>[] = Array.from(stages?.values() ?? []).map((stage) => ({
    value: stage.id,
    displayName: stage.name,
  }));

  return schemaToFormFields(dealTypeConfigFormSchema(stageOptions), ['name', 'dealStageIds']);
}
